/* istanbul ignore file */
import { ApiRequest } from './ApiRequest';

export class AdminApiRequest<T, R = T> extends ApiRequest<T, R> {
  constructor(...path: Array<string | number>) {
    super('admin', 'api', path);
  }
}
